import { type DisplayTextItems } from '../types';
import { DisplayTextViewItem, Space } from './DisplayTextItem';
export const PublisherTextDisplay = ({
  displayItems
}: {
  displayItems: DisplayTextItems;
}) => {
  const {
    publisher,
    customPublisher
  } = displayItems;
  if (customPublisher && customPublisher.value) {
    return <>
        <Space />
        <DisplayTextViewItem item={customPublisher} />
      </>;
  }
  return <>
      <Space data-sentry-element="Space" data-sentry-source-file="PublisherTextDisplay.tsx" />
      <DisplayTextViewItem item={publisher} data-sentry-element="DisplayTextViewItem" data-sentry-source-file="PublisherTextDisplay.tsx" />
    </>;
};